module.exports = __webpack_public_path__ + "img/longbg.5bd2f23d.png";